export default "__VITE_ASSET__ChSA$2UK__"